
import OrderchampLogo from '@marketplace/components/shared/icons/OrderchampLogo.vue'

import EmptyLayout from './empty.vue'

export default {
    name: 'AuthPagesLayout',

    components: {
        EmptyLayout,
        OrderchampLogo,
    },

    head() {
        return {
            htmlAttrs: {
                class: 'overflow-y-auto',
            },
        }
    },
}
